/**
 * Swagger Lucor
 * Swagger Lucor
 *
 * OpenAPI spec version: 1.2.18
 * Contact: roger.cazangi@hotmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { TipoServico } from '../model/tipoServico';
import { NewTipoServico } from '../model/newTipoServico';
import { UpdTipoServico } from '../model/updTipoServico';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';

import { environment } from '../../environments/environment';

@Injectable()
export class TipoServicoApiService {

    protected basePath = environment.apiBasePath;
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Listar Tipos de Serviço
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1TiposervicoGet(observe?: 'body', reportProgress?: boolean): Observable<Array<TipoServico>>;
    public v1TiposervicoGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TipoServico>>>;
    public v1TiposervicoGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TipoServico>>>;
    public v1TiposervicoGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<TipoServico>>('get',`${this.basePath}/v1/tiposervico`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Incluir Novo Tipo de Serviço
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1TiposervicoPost(body?: NewTipoServico, observe?: 'body', reportProgress?: boolean): Observable<TipoServico>;
    public v1TiposervicoPost(body?: NewTipoServico, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TipoServico>>;
    public v1TiposervicoPost(body?: NewTipoServico, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TipoServico>>;
    public v1TiposervicoPost(body?: NewTipoServico, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TipoServico>('post',`${this.basePath}/v1/tiposervico`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Excluir Tipo de Serviço
     * 
     * @param tipoServicoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1TiposervicoTipoServicoIdDelete(tipoServicoId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public v1TiposervicoTipoServicoIdDelete(tipoServicoId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public v1TiposervicoTipoServicoIdDelete(tipoServicoId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public v1TiposervicoTipoServicoIdDelete(tipoServicoId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tipoServicoId === null || tipoServicoId === undefined) {
            throw new Error('Required parameter tipoServicoId was null or undefined when calling v1TiposervicoTipoServicoIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/v1/tiposervico/${encodeURIComponent(String(tipoServicoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obter Tipo de Serviço pelo Id
     * 
     * @param tipoServicoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1TiposervicoTipoServicoIdGet(tipoServicoId: number, observe?: 'body', reportProgress?: boolean): Observable<TipoServico>;
    public v1TiposervicoTipoServicoIdGet(tipoServicoId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TipoServico>>;
    public v1TiposervicoTipoServicoIdGet(tipoServicoId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TipoServico>>;
    public v1TiposervicoTipoServicoIdGet(tipoServicoId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tipoServicoId === null || tipoServicoId === undefined) {
            throw new Error('Required parameter tipoServicoId was null or undefined when calling v1TiposervicoTipoServicoIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<TipoServico>('get',`${this.basePath}/v1/tiposervico/${encodeURIComponent(String(tipoServicoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Atualizar Tipo de Serviço
     * 
     * @param tipoServicoId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1TiposervicoTipoServicoIdPut(tipoServicoId: number, body?: UpdTipoServico, observe?: 'body', reportProgress?: boolean): Observable<TipoServico>;
    public v1TiposervicoTipoServicoIdPut(tipoServicoId: number, body?: UpdTipoServico, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TipoServico>>;
    public v1TiposervicoTipoServicoIdPut(tipoServicoId: number, body?: UpdTipoServico, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TipoServico>>;
    public v1TiposervicoTipoServicoIdPut(tipoServicoId: number, body?: UpdTipoServico, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tipoServicoId === null || tipoServicoId === undefined) {
            throw new Error('Required parameter tipoServicoId was null or undefined when calling v1TiposervicoTipoServicoIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TipoServico>('put',`${this.basePath}/v1/tiposervico/${encodeURIComponent(String(tipoServicoId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
